export const VEHICLE_OUT_OF_ORDER = "VEHICLE_OUT_OF_ORDER";
export const VEHICLE_CANT_WORK = "VEHICLE_CANT_WORK";
export const VEHICLE_LIMITED_WORK = "VEHICLE_LIMITED_WORK";
export const VEHICLE_FULLY_FUNCTIONAL = "VEHICLE_FULLY_FUNCTIONAL";
